export const parseMoney = (value) => {
  if (typeof value === 'number') return Number.isFinite(value) ? value : 0;
  if (value === null || value === undefined) return 0;
  const normalized = String(value).replace(/,/g, '').replace(/[₦$]/g, '').replace(/NGN/gi, '').trim();
  const numeric = Number.parseFloat(normalized);
  return Number.isFinite(numeric) ? numeric : 0;
};

export const formatNaira = (value) =>
  Number(parseMoney(value)).toLocaleString('en-NG', { style: 'currency', currency: 'NGN' });
